import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as RecipeGroupId } from '../../../../../whole-house/canvas/recipe-group/Id';

export const Request = intersect(
	partial({
		id: RecipeGroupId,
		parentId: RecipeGroupId,
		recipeIds: array(iotsUtils.UUID),
	})
)(
	struct({
		name: string,
	})
);
